import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import logTraffic from "./logTraffic";

export default function TrafficTracker() {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      logTraffic({ route: location.pathname, search: location.search });
    }, 150);

    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
